import { WorkflowRole } from '@exam-management/common/types';
import { WorkflowStepCode } from '@exam-management/graphql';
import type { QSetReviewWorkflowStepCode } from '@exam-management/task-management';

export enum QuestionListVariant {
  HIDDEN = 'HIDDEN',
  EMPTY = 'EMPTY',
  PROHIBITED = 'PROHIBITED',
  READONLY = 'READONLY',
}

const variant = {
  [WorkflowRole.TASK_OWNER]: {
    [WorkflowStepCode.ReviewQsetTodo]: QuestionListVariant.EMPTY,
    [WorkflowStepCode.ReviewQsetInReview]: QuestionListVariant.PROHIBITED,
    [WorkflowStepCode.ReviewQsetReviewed]: QuestionListVariant.READONLY,
    [WorkflowStepCode.ReviewQsetDone]: QuestionListVariant.READONLY,
  },
  [WorkflowRole.SUBTASK_ASSIGNER]: {
    [WorkflowStepCode.ReviewQsetTodo]: QuestionListVariant.EMPTY,
    [WorkflowStepCode.ReviewQsetInReview]: QuestionListVariant.PROHIBITED,
    [WorkflowStepCode.ReviewQsetReviewed]: QuestionListVariant.READONLY,
    [WorkflowStepCode.ReviewQsetDone]: QuestionListVariant.READONLY,
  },
  [WorkflowRole.SUBTASK_ASSIGNEE]: {
    [WorkflowStepCode.ReviewQsetTodo]: QuestionListVariant.HIDDEN,
    [WorkflowStepCode.ReviewQsetInReview]: QuestionListVariant.READONLY,
    [WorkflowStepCode.ReviewQsetReviewed]: QuestionListVariant.READONLY,
    [WorkflowStepCode.ReviewQsetDone]: QuestionListVariant.READONLY,
  },
};

export default function getQuestionListVariant(
  roles: { isOwner: boolean; isAssigner: boolean; isAssignee: boolean },
  workflowStepCode: QSetReviewWorkflowStepCode,
): keyof typeof QuestionListVariant | null {
  if (roles.isOwner) {
    return variant[WorkflowRole.TASK_OWNER][workflowStepCode];
  }

  if (roles.isAssigner && roles.isAssignee) {
    // REMARK: if users are assigner and assignee, they are always SUBTASK_ASSIGNEE
    return variant[WorkflowRole.SUBTASK_ASSIGNEE][workflowStepCode];
  }

  if (roles.isAssigner) {
    return variant[WorkflowRole.SUBTASK_ASSIGNER][workflowStepCode];
  }

  if (roles.isAssignee) {
    return variant[WorkflowRole.SUBTASK_ASSIGNEE][workflowStepCode];
  }

  return null;
}
